import type { EntityConfig } from '../types'

export const railAlertEntity: EntityConfig = {
  name: 'rail-alert',
  displayName: 'Alert',
  pluralName: 'Alerts',
  status: {
    field: 'status',
    options: ['new', 'acknowledged', 'investigating', 'resolved'],
    filters: [
      { label: 'All', value: 'all' },
      { label: 'New', value: 'new' },
      { label: 'Acknowledged', value: 'acknowledged' },
      { label: 'Investigating', value: 'investigating' },
      { label: 'Resolved', value: 'resolved' },
    ],
    mappings: {
      all: ['new', 'acknowledged', 'investigating', 'resolved'],
      new: ['new'],
      acknowledged: ['acknowledged'],
      investigating: ['investigating'],
      resolved: ['resolved'],
    },
  },
  queryFields: {
    status: { field: 'status', type: 'select', label: 'Status' },
    severity: { field: 'severity', type: 'select', label: 'Severity' },
    network: { field: 'network', type: 'select', label: 'Network' },
  },
  uiFilterFields: ['status', 'severity', 'network'],
}
